"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import Image from "next/image";

// Import Swiper styles
import "swiper/css";

interface LookItem {
  imageUrl: string; // main design image
  alt: string;
}

interface SolutionsDifferentLookProps {
  items: LookItem[];
  imgBaseUrl: string;
}

export default function SolutionsDifferentLook({ items, imgBaseUrl }: SolutionsDifferentLookProps) {
  return (
    <div className="solutions-different-look">
      <Swiper
        modules={[Autoplay, Navigation, Pagination]}
        spaceBetween={16}
        slidesPerView={1}
        breakpoints={{
          640: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
        loop={true}
        speed={500}
        className="solutions-different-look-swiper"
      >
        {items.map((item, idx) => (
          <SwiperSlide key={`${item.alt}-${idx}`}>
            <div className="space-y-4 aspect-video border-4 overflow-hidden">
              <Image
                src={`${imgBaseUrl}${item.imageUrl}`}
                alt={`${item.alt}-screen`}
                title={`${item.alt}-screen`}
                width={623}
                height={351}
                className="w-full"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}


